import styled from 'styled-components/native'

import { SpacingTypes, ThemeColor } from 'utils/themes/types'

import { BoxBorder } from './types'

type StyledBoxProps = {
  paddingTop?: SpacingTypes | number
  paddingBottom?: SpacingTypes | number
  paddingRight?: SpacingTypes | number
  paddingLeft?: SpacingTypes | number
  marginTop?: SpacingTypes | number
  marginBottom?: SpacingTypes | number
  marginRight?: SpacingTypes | number
  marginLeft?: SpacingTypes | number
  flex?: number
  display?: 'flex' | 'grid' | 'block' | 'inline-block'
  align?: 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around'
  justifyContent?: string
  backgroundColor?: ThemeColor
  textColor?: ThemeColor
  flexDirection?: 'row' | 'column' | 'row-reverse' | 'column-reverse'
  borderRadius?: SpacingTypes
  shadow?: 'sm' | 'md' | 'xl'
  maxWidth?: string | number
  maxHeight?: string | number
  width?: string | number
  height?: string | number
  zIndex?: number
  border?: BoxBorder
  position?: string
}

const getSizeFromStringOrNumber = (value: string | number) =>
  typeof value === 'string' ? value : `${value}px`

export const StyledView = styled.View<StyledBoxProps>`
  ${({
    theme,
    paddingTop,
    paddingBottom,
    paddingRight,
    paddingLeft,
    marginTop,
    marginBottom,
    marginRight,
    marginLeft,
    flex,
    display,
    align,
    justifyContent,
    backgroundColor,
    textColor,
    flexDirection,
    borderRadius,
    shadow,
    maxWidth,
    maxHeight,
    width,
    height,
    zIndex,
    border,
    position,
  }) => {
    const padding = `${
      paddingTop
        ? `padding-top: ${
            typeof paddingTop === 'number' ? paddingTop : theme.spacing[paddingTop as SpacingTypes]
          }px`
        : ''
    } ${
      paddingBottom
        ? `padding-bottom: ${
            typeof paddingBottom === 'number'
              ? paddingBottom
              : theme.spacing[paddingBottom as SpacingTypes]
          }px`
        : ''
    } ${
      paddingLeft
        ? `padding-left: ${
            typeof paddingLeft === 'number'
              ? paddingLeft
              : theme.spacing[paddingLeft as SpacingTypes]
          }px`
        : ''
    } ${
      paddingRight
        ? `padding-right: ${
            typeof paddingRight === 'number'
              ? paddingRight
              : theme.spacing[paddingRight as SpacingTypes]
          }px`
        : ''
    }`

    const margin = `${
      marginTop
        ? `margin-top: ${
            typeof marginTop === 'number' ? marginTop : theme.spacing[marginTop as SpacingTypes]
          }px`
        : ''
    } ${
      marginBottom
        ? `margin-bottom: ${
            typeof marginBottom === 'number'
              ? marginBottom
              : theme.spacing[marginBottom as SpacingTypes]
          }px`
        : ''
    } ${
      marginLeft
        ? `margin-left: ${
            typeof marginLeft === 'number' ? marginLeft : theme.spacing[marginLeft as SpacingTypes]
          }px`
        : ''
    } ${
      marginRight
        ? `margin-right: ${
            typeof marginRight === 'number'
              ? marginRight
              : theme.spacing[marginRight as SpacingTypes]
          }px`
        : ''
    }`

    const flexStyle = flex ? `flex: ${flex}` : ''
    const displayStyle = display ? `display: ${display}` : ''
    const alignStyle = align ? `align-items: ${align}` : ''
    const justifyContentStyle = justifyContent ? `justify-content: ${justifyContent}` : ''
    const backgroundColorStyle = backgroundColor
      ? `background-color: ${theme.colors[backgroundColor]};`
      : ''
    const textColorStyle = textColor ? `color: ${theme.colors[textColor]};` : ''
    const flexDirectionStyle = flexDirection ? `flex-direction: ${flexDirection}` : ''
    const borderRadiusStyle = borderRadius ? `border-radius: ${theme.spacing[borderRadius]}px` : ''
    const maxWidthStyle = maxWidth ? `max-width: ${getSizeFromStringOrNumber(maxWidth)}` : ''
    const maxHeightStyle = maxHeight ? `max-height: ${getSizeFromStringOrNumber(maxHeight)}` : ''
    const widthStyle = width ? `width: ${getSizeFromStringOrNumber(width)}` : ''
    const heightStyle = height ? `height: ${getSizeFromStringOrNumber(height)}` : ''
    const shadowStyle = shadow ? `box-shadow: ${theme.shadow[shadow]}` : ''
    const zIndexStyle = zIndex ? `z-index: ${zIndex};` : ''
    const borderStyle = border
      ? `border: ${border.width}px solid ${theme.colors[border.color]};`
      : ''
    const positionStyle = position ? `position: ${position};` : ''

    return `
      ${padding}
      ${margin}
      ${flexStyle}
      ${displayStyle}
      ${alignStyle}
      ${justifyContentStyle}
      ${backgroundColorStyle}
      ${textColorStyle}
      ${flexDirectionStyle}
      ${borderRadiusStyle}
      ${maxWidthStyle}
      ${maxHeightStyle}
      ${widthStyle}
      ${heightStyle}
      ${shadowStyle}
      ${zIndexStyle}
      ${borderStyle}
      ${positionStyle}
    `
  }};
}>
`
